import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      light: {
        'secondary-card': '#e8e8e8',
        background: '#f5f5f5',
        components: '#ffffff',
        primary: '#4921df', // #E53935
        secondary: '#2f2f2f', // #FFCDD2
        accent: '#e90c60', // #3F51B5
      },
      dark: {
        'secondary-card': '#27272f',
        background: '#25272f',
        components: '#23232d',
        primary: '#4921df', // #E53935
        secondary: '#2f2f2f', // #FFCDD2
        accent: '#e90c60', // #3F51B5
      },
    },
  },
})
